import { useInfiniteQuery } from '@tanstack/react-query'
import type { DirectoryPlumberListResponse } from '../types'
export function useDirectoryPlumbersInfinite(
  queryKey: readonly unknown[],
  fetchPage: (skip: number) => Promise<DirectoryPlumberListResponse>,
  enabled: boolean,
) {
  return useInfiniteQuery({
    queryKey,
    queryFn: ({ pageParam }) =>
      fetchPage(pageParam as number),
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages) => {
      const loaded = allPages.reduce((sum, p) => sum + p.plumbers.length, 0)
      return loaded < lastPage.total ? loaded : undefined
    },
    enabled,
  })
}
